import type { ActionStatus } from '../types/actions';
import type { InspectionReportSnapshot, InspectionReportSummary } from '../types/report';

const submittedOrActiveStatuses = new Set<ActionStatus>([
  'submitted',
  'acknowledged',
  'in_progress',
  'rectification_claimed',
  'disputed',
]);

export function buildInspectionReportSummary(
  snapshot: InspectionReportSnapshot,
): InspectionReportSummary {
  const actions = snapshot.issues.flatMap((issue) => (issue.action ? [issue.action] : []));

  return {
    answeredChecks: snapshot.responses.length,
    totalFindings: snapshot.issues.length,
    openFindings: snapshot.issues.filter((issue) => !['closed', 'waived'].includes(issue.status)).length,
    closedFindings: snapshot.issues.filter((issue) => issue.status === 'closed').length,
    waivedFindings: snapshot.issues.filter((issue) => issue.status === 'waived').length,
    urgentFindings: snapshot.issues.filter(
      (issue) => issue.priority === 'immediate' || issue.priority === 'urgent',
    ).length,
    totalActions: actions.length,
    submittedOrActiveActions: actions.filter((action) => submittedOrActiveStatuses.has(action.status)).length,
    rectificationClaimed: actions.filter((action) => action.status === 'rectification_claimed').length,
    verifiedClosedActions: actions.filter((action) => action.status === 'verified_closed').length,
  };
}

export function formatReportStatus(value: string): string {
  return value.replaceAll('_', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function reportProjectLabel(snapshot: InspectionReportSnapshot): string {
  return snapshot.projectName ?? snapshot.property.manual_project_name ?? 'Project not recorded';
}

export function reportDeveloperLabel(snapshot: InspectionReportSnapshot): string {
  return snapshot.developerName ?? snapshot.property.manual_developer_name ?? 'Developer not recorded';
}
